/* unplugin-vue-components disabled */import { render } from "./ClientProtocolsViewDialog.vue?vue&type=template&id=263584ac&scoped=true"
import script from "./ClientProtocolsViewDialog.vue?vue&type=script&lang=js"
export * from "./ClientProtocolsViewDialog.vue?vue&type=script&lang=js"

import "./ClientProtocolsViewDialog.vue?vue&type=style&index=0&id=263584ac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-263584ac"]])

export default __exports__